export const siteConfig = {
  brandName: "Subedi Tax Pro",
  domain: "subeditax.com",
  contactEmail: "gaurab@subeditax.com",
  // Client-facing support line. Also quoted in the HELP auto-reply carriers send for our toll-free
  // number, so the two must not drift apart.
  contactPhone: "(279) 333-9136",
  year: "2026",
  founderName: "Gaurab Subedi",
  founderRole: "Founder & Tax Preparer",
  founderBioTitle: "CTEC Registered Tax Preparer",
  // Credential *numbers* are deliberately not rendered on the public page: a published PTIN/EFIN
  // pair is what return-fraud rings need, and neither is consumer-verifiable anyway. The CRTP
  // number is the exception — CTEC runs a public lookup, and B&P 22253 requires disclosing it.
  ctecNumber: "",
  countyLicense: "GNB32026-02192",
  jurisdiction: "Sacramento County, California",
  linkedinUrl: "https://www.linkedin.com/in/subedigaurab/",
  businessHours: "Mon – Sat: 9:00 AM – 6:00 PM PT",
  location: "Antelope, Sacramento County, CA",
};

// The marketing bundle cannot import from the portal API client without dragging the portal chunk
// into the landing page, so the base URL is resolved here the same way `portalApi` resolves it.
// Empty string means same-origin, which is what local dev serves.
export const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(/\/+$/, "") ?? "";

export const mailtoHref = (subject: string, body: string) => {
  const params = new URLSearchParams({ subject, body });
  return `mailto:${siteConfig.contactEmail}?${params.toString()}`;
};
